<template>
  <i class="v-icon mdi theme--light" :class="`mdi-${iconName}`"/>
</template>

<script>
export default {
  name: "v-custom-icon",
  props:{
    iconName:{
      type: String,

    }
  },
};
</script>

<style lang="scss">

</style>
